import { Component, Input, OnInit } from '@angular/core';
import { I18NService } from '../../../../../../services/i18-n.service';

@Component({
  selector: 'app-edition-sidebar-item',
  templateUrl: './edition-sidebar-item.component.html',
  styleUrls: ['./edition-sidebar-item.component.scss'],
})
export class EditionSidebarItemComponent implements OnInit {
  @Input() public field: any;

  constructor(private i18nService: I18NService) { }

  private labels: Record<string, string> = {};

  private readonly labelKeys: Record<string, { key: string; fallback: string }> = {
    format: { key: 'format', fallback: 'Format' },
    title: { key: 'title', fallback: 'Title' },
    author: { key: 'editionDetailsAuthor', fallback: 'Author' },
    publisherInfo: { key: 'publisherInformation', fallback: 'Publisher Information' },
    isbn: { key: 'editionDetailsIsbn', fallback: 'ISBN' },
    physicalDescription: { key: 'physicalDescription', fallback: 'Physical Description' },
    bibId: { key: 'bibId', fallback: 'Bib ID' },
    abbrTitle: { key: 'abbreviatedTitle', fallback: 'Abbreviated Title' },
    noteAwards: { key: 'editionDetailsAwardsNote', fallback: 'Awards Note' },
    noteCredits: { key: 'creditsNote', fallback: 'Credits Note' },
    noteDissertation: { key: 'editionDetailsDissertation', fallback: 'Dissertation Note' },
    edition: { key: 'edition', fallback: 'Edition' },
    formerTitle: { key: 'formerTitle', fallback: 'Former Title' },
    frequency: { key: 'frequency', fallback: 'Frequency' },
    issn: { key: 'editionDetailsIssn', fallback: 'ISSN' },
    upc: { key: 'editionDetailsUpc', fallback: 'UPC' },
    noteAudience: { key: 'intendedAudience', fallback: 'Intended Audience' },
    electronicNote: { key: 'editionDetailsElectronicNote', fallback: 'Note (electronic)' },
    seriesTitle: { key: 'editionDetailsSeriesTitle', fallback: 'Series Title' },
    supplementaryContent: { key: 'supplementInformation', fallback: 'Supplement Information' },
    noteTableOfContents: { key: 'tableOfContents', fallback: 'Table of Contents' },
    vendor: { key: 'vendorInformationLabel', fallback: 'Vendor' },
    fullTitle: { key: 'editionDetailsFullTitle', fallback: 'Full Title Details' },
    uniformTitle: { key: 'editionDetailsUniformTitle', fallback: 'Uniform Title' },
    alternateTitle: { key: 'editionDetailsAlternateTitle', fallback: 'Alternate Title' },
    addedTitle: { key: 'editionDetailsAddedTitle', fallback: 'Added Title' },
    languageInformation: { key: 'editionDetailsLanguageInformation', fallback: 'Language Information' },
    itemLanguage: { key: 'editionDetailsItemLanguage', fallback: 'Item Language' },
    workLanguage: { key: 'editionDetailsWorkLanguage', fallback: 'Work Language' },
    fullLanguageDetails: { key: 'editionDetailsFullLanguageDetails', fallback: 'Full Language Details' },
    langIncludesText: { key: 'editionDetailsLanguageIncludesText', fallback: 'This edition includes text in' },
    langSummary: { key: 'editionDetailsLanguageSummary', fallback: 'The summary is in' },
    langSungSpoken: { key: 'editionDetailsLanguageSungSpoken', fallback: 'Sung or spoken text in' },
    langLibrettos: { key: 'editionDetailsLanguageLibrettos', fallback: 'Librettos language is' },
    langTableOfContents: { key: 'editionDetailsLanguageTableOfContents', fallback: 'Table of Contents is in' },
    langAccMaterials: { key: 'editionDetailsLanguageAccMaterial', fallback: 'Accompanying materials in' },
    langOrigTranslatedFrom: { key: 'editionDetailsLanguageOrigTranslatedFrom', fallback: 'Original text translated from' },
    langIntertitles: { key: 'editionDetailsLanguageIntertitles', fallback: 'Item has intertitles in' },
    langSubtitles: { key: 'editionDetailsLanguageSubtitles', fallback: 'Item has subtitles in' },
    langInterTranslation: { key: 'editionDetailsLanguageInterTranslatedFrom', fallback: 'Intermediate translations text translated from' },
    langOrigAccMaterials: { key: 'editionDetailsLanguageOrigAccMat', fallback: 'Original accompanying materials in' },
    langOrigLibrettos: { key: 'editionDetailsLanguageOrigLibrettos', fallback: 'Original librettos language is' },
    langCaptions: { key: 'editionDetailsLanguageCaptions', fallback: 'Captions available in' },
    langAccessibleAudio: { key: 'editionDetailsLanguageAccessibleAudio', fallback: 'Accessible audio in' },
    langAccessibleVisual: { key: 'editionDetailsLanguageAccessibleVisual', fallback: 'Accessible visual language (non-textual) in' },
    langAccTranscripts: { key: 'editionDetailsLanguageAccTranscripts', fallback: 'Accompanying transcripts for audiovisual materials in' },
    accessibilityInfo: { key: 'editionDetailsAccessibilityInfo', fallback: 'Accessibility Information' },
    accessibilityNote: { key: 'editionDetailsAccessibilityNote', fallback: 'Accessibility Note' },
    swissCollections: { key: 'editionDetailsSwissCollections', fallback: 'Swiss Collections' },
    subjects: { key: 'editionDetailsSubjects', fallback: 'Subjects' },
    subjPersonalName: { key: 'editionDetailsPersonalName', fallback: 'Personal Name' },
    subjCorporateName: { key: 'editionDetailsCorporateName', fallback: 'Corporate Name' },
    subjMeetingName: { key: 'editionDetailsMeetingName', fallback: 'Meeting Name' },
    subjNamedEvent: { key: 'editionDetailsNamedEvent', fallback: 'Named Event' },
    subjChronologicalTerm: { key: 'editionDetailsChronologicalTerm', fallback: 'Chronological Term' },
    subjTopicalTerm: { key: 'editionDetailsTopicalTerm', fallback: 'Topical Term' },
    subjUncontrolledTerm: { key: 'editionDetailsUncontrolledTerm', fallback: 'Uncontrolled Term' },
    subjFacetedTopicTerm: { key: 'editionDetailsFacetedTopicTerm', fallback: 'Faceted Topic Term' },
    subjGenre: { key: 'editionDetailsGenre', fallback: 'Genre' },
    subjOccupation: { key: 'editionDetailsOccupation', fallback: 'Occupation' },
    subjFunction: { key: 'editionDetailsFunction', fallback: 'Function' },
    subjCurriculumObj: { key: 'editionDetailsCurriculumObj', fallback: 'Curriculum Objective' },
    subjPlaceName: { key: 'editionDetailsPlaceName', fallback: 'Hierarchical Place Name' },
    subjEntityType: { key: 'editionDetailsEntityType', fallback: 'Entity Type' },
    subjLocal: { key: 'editionDetailsLocalSubjects', fallback: 'Local Subjects' },
    noteTitle: { key: 'editionDetailsNoteTitle', fallback: 'Note' },
    noteGeneral: { key: 'editionDetailsGeneralNote', fallback: 'General Note' },
    noteWith: { key: 'editionDetailsWithNote', fallback: 'With Note' },
    noteBibliography: { key: 'editionDetailsBibliographyNote', fallback: 'Bibliography, etc. Note' },
    noteRestrictions: { key: 'editionDetailsRestrictionsNote', fallback: 'Restrictions on Access Note' },
    noteScale: { key: 'editionDetailsScaleNote', fallback: 'Scale Note for Visual Materials' },
    noteCitation: { key: 'editionDetailsCitationNote', fallback: 'Citation/References Note' },
    noteParticipant: { key: 'editionDetailsParticipantNote', fallback: 'Participant or Performer Note' },
    noteReport: { key: 'editionDetailsReportNote', fallback: 'Type of Report and Period Covered Note' },
    noteDataQuality: { key: 'editionDetailsDataNote', fallback: 'Data Quality Note' },
    noteNumbering: { key: 'editionDetailsNumberingNote', fallback: 'Numbering Peculiarities Note' },
    noteComputerFileType: { key: 'editionDetailsComputerFileTypeNote', fallback: 'Type of Computer File or Data Note' },
    noteEvent: { key: 'editionDetailsEventNote', fallback: 'Date/Time and Place of an Event Note' },
    noteSummary: { key: 'editionDetailsSummary', fallback: 'Summary' },
    noteGeographic: { key: 'editionDetailsGeographicNote', fallback: 'Geographic Note' },
    notePrefCitation: { key: 'editionDetailsPrefCitationNote', fallback: 'Preferred Citation of Described Materials Note' },
    noteSupplement: { key: 'editionDetailsSupplementNote', fallback: 'Supplement Note' },
    noteStudyProgram: { key: 'editionDetailsStudyProgramNote', fallback: 'Study Program Information Note' },
    noteAddlForm: { key: 'editionDetailsAddlFormNote', fallback: 'Additional Physical Form Available Note' },
    noteAccessibility: { key: 'editionDetailsAccessibilityNote', fallback: 'Accessibility Note' },
    noteReproduction: { key: 'editionDetailsReproductionNote', fallback: 'Reproduction Note' },
    noteOriginalVersion: { key: 'editionDetailsOriginalVersionNote', fallback: 'Original Version Note' },
    noteLocationOriginals: { key: 'editionDetailsLocationOfOriginalsNote', fallback: 'Location of Originals/Duplicates Note' },
    noteFunding: { key: 'editionDetailsFundingNote', fallback: 'Funding Information Note' },
    noteSystemDetails: { key: 'editionDetailsSystemDetailsNote', fallback: 'System Details Note' },
    noteTermsOfUse: { key: 'editionDetailsTermsNote', fallback: 'Terms Governing Use and Reproduction Note' },
    noteSourceOfAcq: { key: 'editionDetailsSourceOfAcqNote', fallback: 'Immediate Source of Acquisition Note' },
    noteCopyrightStatus: { key: 'editionDetailsCopyrightStatusNote', fallback: 'Information Relating to Copyright Status' },
    noteLocationOtherMaterials: { key: 'editionDetailsLocationOtherMaterialsNote', fallback: 'Location of Other Archival Materials Note' },
    noteBiographical: { key: 'editionDetailsBiographicalNote', fallback: 'Biographical or Historical Data Note' },
    noteLanguage: { key: 'editionDetailsLanguageNote', fallback: 'Language Note' },
    noteFormerTitle: { key: 'editionDetailsFormerTitleNote', fallback: 'Former Title Complexity Note' },
    noteIssuingBody: { key: 'editionDetailsIssuingBodyNote', fallback: 'Issuing Body Note' },
    noteEntityInfo: { key: 'editionDetailsEntityInfoNote', fallback: 'Entity and Attribute Information Note' },
    noteCumulativeIndex: { key: 'editionDetailsCumulativeIndexNote', fallback: 'Cumulative Index/Finding Aids Note' },
    noteDocumentationInfo: { key: 'editionDetailsDocumentationInfoNote', fallback: 'Information about Documentation Note' },
    noteOwnership: { key: 'editionDetailsOwnershipHistoryNote', fallback: 'Ownership and Custodial History' },
    noteCopyVersion: { key: 'editionDetailsCopyVersionNote', fallback: 'Copy and Version Identification Note' },
    noteBinding: { key: 'editionDetailsBindingInfo', fallback: 'Binding Information' },
    noteCaseFile: { key: 'editionDetailsCaseFileNote', fallback: 'Case File Characteristics Note' },
    noteMethodology: { key: 'editionDetailsMethodologyNote', fallback: 'Methodology Note' },
    noteLinkingEntry: { key: 'editionDetailsLinkingEntryNote', fallback: 'Linking Entry Complexity Note' },
    notePublications: { key: 'editionDetailsPublicationsNote', fallback: 'Publications About Described Materials Note' },
    noteAction: { key: 'editionDetailsActionNote', fallback: 'Action Note' },
    noteAccumulation: { key: 'editionDetailsAccumulationNote', fallback: 'Accumulation and Frequency of Use Note' },
    noteExhibitions: { key: 'editionDetailsExhibitionsNote', fallback: 'Exhibitions Note' },
    noteSourceOfDesc: { key: 'editionDetailsSourceOfDescNote', fallback: 'Source of Description, Etc. Note' },
    noteLocal: { key: 'editionDetailsLocalNotes', fallback: 'Local Notes' },
    contributors: { key: 'editionDetailsContributors', fallback: 'Contributors' },
    controlNumbers: { key: 'editionDetailsControlNumbers', fallback: 'Control Numbers' },
    publisherNumber: { key: 'editionDetailsPublisherNumber', fallback: 'Publisher or Distributor Number' },
    subjGeographicName: { key: 'editionDetailsGeographicName', fallback: 'Geographic Name' },
  };

  public customTranslateValue(key:string, value: any): string {
    return this.i18nService.getTranslation(key+value) || value;
  }

  public ngOnInit() {
    this.initializeLabels();
  }

  private initializeLabels(): void {
    this.labels = Object.entries(this.labelKeys).reduce(
      (acc, [key, { key: translationKey, fallback }]) => {
        acc[key] =
          this.i18nService.getTranslation(translationKey) ||
          fallback ||
          this.toLabel(key);
        return acc;
      },
      {} as Record<string, string>
    );
  }

  public labelFor(key: string): string {
    return this.labels[key] ?? this.toLabel(key);
  }

  public isArray(value: unknown): value is unknown[] {
    return Array.isArray(value) && value.length > 1;
  }

  public isEmpty(value: unknown): boolean {
    if (value == null) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'string') return value.trim().length === 0;
    return false;
  }

  private toLabel(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (m) => m.toUpperCase())
      .trim();
  }
}
